<template>
    <v-layout
        v-if=" ariclesCount / articlesPerPage > 1 "
        :class="['blog-pagination']"
    >

        <v-flex
            v-if="firstNumber > 1"
            :class="['blog-pagination__arrow', 'blog-pagination__arrow-prev']"
        >
            <a @click="goToPreviousPage">
                <img :src="'/svg/pagination-arrow.svg'"/>
            </a>
        </v-flex>

        <v-flex
            v-for="item in pagination"
            :key="item.number"
            :class="['blog-pagination__item', item.number == currentPage ? 'blog-pagination__item-active' : '']"
        >
            <a :href="item.link">{{ item.number }}</a>
        </v-flex>

        <v-flex
            v-if="currentPage < Math.ceil(ariclesCount/articlesPerPage) && ariclesCount / articlesPerPage > 5"
            :class="['blog-pagination__arrow', 'blog-pagination__arrow-next']"
        >
            <a @click="goToNextPage">
                <img :src="'/svg/pagination-arrow.svg'"/>
            </a>
        </v-flex>

    </v-layout>
</template>

<script>
export default {
    props: ['pages', 'category'],
    name: "Pagination",
    data: () => ({
        currentPage: 1,
        previousPage: 0,
        nextPage: 2,
        firstNumber: 0,
        articlesPerPage: 10,
        ariclesCount: 0,
        pagesCount: 1,
        pagination: [],
    }),

    created () {
        this.initValues()
        this.setFirstNumber()
        this.setPaginationItems()
    },

    methods: {
        initValues(){
            this.currentPage = this.pages.currentPage ? this.pages.currentPage : this.currentPage
            this.articlesPerPage = this.pages.articlesPerPage ? this.pages.articlesPerPage : this.articlesPerPage
            this.ariclesCount = this.pages.ariclesCount ? this.pages.ariclesCount : this.ariclesCount
            this.pagesCount = Math.ceil( this.ariclesCount / this.articlesPerPage )
            this.previousPage = parseInt(this.currentPage) - 1
            this.nextPage = parseInt(this.currentPage) + 1
        },

        setFirstNumber(){
            if(this.currentPage >= 1 && this.currentPage <= 3){
                this.firstNumber = 1
                return
            }
            let lastPage = Math.ceil(ariclesCount / articlesPerPage)
            if(this.currentPage >= lastPage - 2 && this.currentPage <= lastPage){
                this.firstNumber = this.currentPage - 4
                return
            }
            this.firstNumber = this.currentPage - 2
        },

        setPaginationItems(){
            for(let i = 0; i < this.pagesCount && i < 5; i++){
                this.pagination.push({
                    number: this.firstNumber + i,
                    link: window.location.pathname + (this.category ? ('?categories=' + Array.from(this.category, item => item.id).join(',') + '&page=') : '?page=') + (this.firstNumber + i)
                })
            }
        },

        goToPreviousPage(){
            this.pagination.find((item) => {
                if (item.number == this.previousPage){
                    document.location.href = item.link
                }
            })
        },

        goToNextPage(){
            this.pagination.find((item) => {
                if (item.number == this.nextPage){
                    document.location.href = item.link
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/blog/Pagination.vue